import {
  defineNuxtRouteMiddleware,
  useNuxtApp,
  useRuntimeConfig,
} from 'nuxt/app'
import type { RouteLocationNormalized } from 'vue-router'
import { getMetaFromRoute } from '../utility/route'

declare module 'vue' {
  interface ComponentCustomOptions {
    httpHeaders?: (to: RouteLocationNormalized) => Record<string, string>
  }
}

export default defineNuxtRouteMiddleware((to) => {
  // Only run on server-side
  if (process.server) {
    const nuxtApp = useNuxtApp()
    const headers: Record<string, string> = {}
    const meta = getMetaFromRoute(to)

    // Check for httpHeaders in page meta
    const pageHttpHeaders = meta?.httpHeaders
    if (typeof pageHttpHeaders === 'function') {
      Object.assign(headers, pageHttpHeaders(to))
    } else if (to.matched[0]?.components?.default?.httpHeaders) {
      Object.assign(
        headers,
        to.matched[0].components.default.httpHeaders({
          route: to,
          $config: useRuntimeConfig(),
        }),
      )
    }

    // Set default cache control if none exists
    if (!headers['Cache-Control']) {
      headers['Cache-Control'] = 'max-age=0, private'
      headers.Grace = '0'
    }

    // Set headers on the response
    if (nuxtApp.ssrContext?.event) {
      Object.entries(headers).forEach(([key, value]) => {
        const existingHeader = nuxtApp.ssrContext!.event.node.res.getHeader(key)
        if (existingHeader) {
          // Merge existing header with new value
          const mergedValue = `${existingHeader} ${value}`
          nuxtApp.ssrContext!.event.node.res.setHeader(key, mergedValue)
        } else {
          nuxtApp.ssrContext!.event.node.res.setHeader(key, value)
        }
      })
    }
  }
})
